import { Component, OnInit } from "@angular/core";
import { Order } from "../models/order";

@Component({
  selector: "app-order-board",
  templateUrl: "./order-board.component.html",
  styleUrls: ["./order-board.component.css"],
})
export class OrderBoardComponent implements OnInit {
  order = {} as Order;
  orders: Array<Order>;

  constructor() {}

  ngOnInit(): void {}
}
